module.exports = __webpack_public_path__ + "img/kz.22705abc.png";